import React from 'react'

import { Box, Typography } from '@material-ui/core'

import { DashboardChartPaper } from 'components'

import useStyles from './styles'

const CardsListStructure = ({ title, emptyMessage, isEmpty, children }) => {
  const classes = useStyles()

  return (
    <DashboardChartPaper title={title} noMaxHeight>
      <Box className={classes.root}>
        {isEmpty ? (
          <Box className={classes.emptyState}>
            <Typography variant="body2">{emptyMessage}</Typography>
          </Box>
        ) : (
          children
        )}
      </Box>
    </DashboardChartPaper>
  )
}

export default CardsListStructure
